// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { NotificationTypes } from "./NotificationTypes";
import {
  NotificationTypesFromJSON,
  NotificationTypesFromJSONTyped,
  NotificationTypesToJSON,
  NotificationTypesToJSONTyped,
} from "./NotificationTypes";

/**
 *
 * @export
 * @interface Subscription
 */
export interface Subscription {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  userId: string;
  /**
   *
   */
  tenant: string;
  /**
   *
   */
  notificationType: NotificationTypes;
}

/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): value is Subscription {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (
    (!("userId" in (value as Record<string, any>)) &&
      !("user_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["userId"] === undefined &&
      (value as Record<string, any>)["user_id"] === undefined)
  )
    return false;
  if (!("tenant" in value) || value["tenant"] === undefined) return false;
  if (
    (!("notificationType" in (value as Record<string, any>)) &&
      !("notification_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["notificationType"] === undefined &&
      (value as Record<string, any>)["notification_type"] === undefined)
  )
    return false;
  return true;
}

export function SubscriptionFromJSON(json: any): Subscription {
  return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    userId: json["user_id"],
    tenant: json["tenant"],
    notificationType: NotificationTypesFromJSON(json["notification_type"]),
  };
}

export function SubscriptionToJSON(json: any): Subscription {
  return SubscriptionToJSONTyped(json, false);
}

export function SubscriptionToJSONTyped(
  value?: Subscription | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    user_id: value["userId"],
    tenant: value["tenant"],
    notification_type: NotificationTypesToJSON(value["notificationType"]),
  };
}
